const Colors = {
    selectedRow: '#ffbe76ff'
}

export default Colors